// put in your config overrides here
var ConfigDev = {
  applicationRenderDelay: 100,
  rootUrl: "",
  historyServer: "",
  analyticsKey: "39uhSEOoRHMw6cMR6st9tYXDbAL3JSaP",
  stateRefresh: 3000,
  useFixtures: false,
  useUIConfigFixtures: false
};

module.exports = ConfigDev;



// WEBPACK FOOTER //
// ./src/js/config/Config.test.js